exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applicant[data-v-929439ce]{border-left:4px solid #1976d2!important}.section-heading[data-v-929439ce]{display:flex;align-items:center}", ""]);

// exports
